import Hero from "../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import BorrowCalculator from "./calculators/MortgageBorrowCalculator";
import SEO from "../designSystem/SEO";


const MortgageBorrowCalculatorsPage = () => {
    return (
      <div>
        <SEO
          title="Mortgage Affordability Calculator"
          description="Estimate how much you may be able to borrow based on your income, deposit and circumstances with our mortgage affordability calculator."
          path="/calculators/mortgage-affordability"
        />
        <Hero
          //         title={`Financial Clarity
          // Direction & Confidence`}
          //         subtitle="Wealth Management Solutions"
          showOverlay={true}
          // backgroundImage={HeroBackground}
          titleAlign="center"
          subtitleAlign="center"
          pageTitle="Calculators"
          title="Mortgage Affordability"
          subtitle="Knowing how much you could potentially borrow is an important part of planning your next move. Our Mortgage Affordability Calculator gives you an indication of the mortgage amount you may be able to afford based on your income and financial circumstances, helping you get a clearer idea of your potential budget."
          showButton={true}
          textAlign="center"
        ></Hero>

        <BorrowCalculator />
        {/* <div className="landing-page">
            </div> */}
      </div>
    );
}

export default MortgageBorrowCalculatorsPage;
